import { render, staticRenderFns } from "./Paging.vue?vue&type=template&id=6c2f7c48&"
import script from "./Paging.vue?vue&type=script&lang=js&"
export * from "./Paging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports